import { memo } from "react";
import { ClaudeCodePreview } from "./claude-code";
import { TermWindow } from "./frame";
import { HerdrPane, HerdrSidebar, HerdrTabs, HerdrToast } from "./herdr";
import { NeovimPreview } from "./neovim";
import { TerminalBody } from "./terminal";
import { v } from "./vars";
import { WeeChatPreview } from "./weechat";

/** Everything at once: Ghostty → herdr → Neovim, Claude Code, WeeChat and a shell. */
export const WorkspacePreview = memo(function WorkspacePreview() {
  return (
    <TermWindow
      title="herdr — themes"
      className="h-full"
      bodyClassName="flex text-[11px] leading-[1.45]"
    >
      <div className="relative flex min-w-0 flex-1" style={{ background: v("herdr.panel_bg") }}>
        <HerdrSidebar compact />
        <div className="flex min-w-0 flex-1 flex-col">
          <HerdrTabs compact />
          <div className="grid min-h-0 flex-1 grid-cols-[1.25fr_1fr] grid-rows-[1.3fr_1fr] gap-[2px] p-[2px]">
            <HerdrPane focused label="nvim · tokens.ts">
              <NeovimPreview compact />
            </HerdrPane>
            <HerdrPane label="claude · working">
              <ClaudeCodePreview compact />
            </HerdrPane>
            <HerdrPane label="weechat · #neovim">
              <WeeChatPreview compact />
            </HerdrPane>
            <HerdrPane label="fish · ~/code/themes">
              <TerminalBody compact />
            </HerdrPane>
          </div>
        </div>
        <HerdrToast />
      </div>
    </TermWindow>
  );
});
